import {create, destroy, get, update} from "custom/demo/requests/admin/validation-surveys";
import Field from "components/helpers/form/field";
import useForm from "custom/demo/helpers/admin/use-form";

const styleOptions = [
  {name: "Cognitive", value: "Cognitive"},
  {name: "Personality", value: "Personality"},
  {name: "Questionnaire", value: "Questionnaire"}
];

const defaults = {
  key: "",
  name: "",
  questionnaire: "",
  style: "Cognitive"
};

export default function Form() {
  const {id, onChange, onDestroy, onSubmit, record} = useForm({
    actions: {create, destroy, get, update}, defaults, path: "/admin/validation/surveys"
  });

  return (
    <div className="container">
      <h1>Validation Survey</h1>
      <form onSubmit={onSubmit}>
        <Field
          label="Key"
          name="key"
          onChange={onChange}
          placeholder="Key"
          required={true}
          value={record.key}
        />
        <Field
          label="Name"
          name="name"
          onChange={onChange}
          placeholder="Name"
          required={true}
          value={record.name}
        />
        <Field
          label="Style"
          name="style"
          onChange={onChange}
          options={styleOptions}
          type="select"
          value={record.style}
        />
        {record.style === "Questionnaire" && (
          <label className="block mb-2" htmlFor="questionnaire">
            <div>Questionnaire</div>
            <textarea
              id="questionnaire"
              name="questionnaire"
              onChange={onChange}
              placeholder="JSON"
              rows={10}
              value={record.questionnaire || ""}
            />
          </label>
        )}
        <div className="flex gap-2 mt-4">
          <button className="btn btn-blue" type="submit">Save</button>
          {id && <button className="btn btn-red" onClick={onDestroy} type="button">Delete</button>}
        </div>
      </form>
    </div>
  );
}
